/* Souvence — dictionnaire pays multilingue (FR / EN / ES / DE) pour la recherche
   de couvertures. UNE info, UN seul endroit : les deux pop-ups (gabarit cta-up
   via sections/main-product.liquid, et gabarit travel-v2 via
   sections/sv-pdp-buybox.liquid) lisent ce fichier.

   Principe : les titres des couvertures sont en ANGLAIS (Paris, Greece...) et le
   regroupement se fait sur le metachamp `custom.template_country` (valeurs
   anglaises). Il suffit donc qu'un mot tape dans n'importe quelle langue "pointe"
   vers le bon PAYS anglais : ensuite le regroupement par pays fait le reste.

   Cle  = nom de pays tape (FR/ES/DE + formes courtes EN), accents/casse ignores.
   Valeur = nom de pays ANGLAIS (= valeur du metachamp), casse/accents ignores.

   Ajouter une langue = ajouter des cles ici, rien d'autre a toucher.
   Villes NON couvertes volontairement : taper le pays ramene deja ses villes. */
(function (root) {
  'use strict';

  function norm(s) {
    return String(s == null ? '' : s).toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '')   // accents
      .replace(/[^a-z0-9]+/g, ' ')                          // ponctuation
      .replace(/\s+/g, ' ').trim();
  }

  /* alias (une langue) -> pays anglais. Les cles peuvent porter des accents :
     elles sont normalisees au chargement. */
  var MAP = {
    'albanie': 'Albania', 'albania': 'Albania', 'albanien': 'Albania',
    'argentine': 'Argentina', 'argentina': 'Argentina', 'argentinien': 'Argentina',
    'aruba': 'Aruba',
    'australie': 'Australia', 'australia': 'Australia', 'australien': 'Australia',
    'bresil': 'Brazil', 'brésil': 'Brazil', 'brasil': 'Brazil', 'brasilien': 'Brazil', 'brazil': 'Brazil',
    'canada': 'Canada', 'kanada': 'Canada',
    'chine': 'China', 'china': 'China',
    'colombie': 'Colombia', 'colombia': 'Colombia', 'kolumbien': 'Colombia',
    'costa rica': 'Costa Rica',
    'croatie': 'Croatia', 'croacia': 'Croatia', 'kroatien': 'Croatia', 'croatia': 'Croatia',
    'republique dominicaine': 'Dominican Republic', 'république dominicaine': 'Dominican Republic',
    'republica dominicana': 'Dominican Republic', 'dominikanische republik': 'Dominican Republic',
    'dominicaine': 'Dominican Republic', 'dominicana': 'Dominican Republic', 'dominican republic': 'Dominican Republic',
    'egypte': 'Egypt', 'égypte': 'Egypt', 'egipto': 'Egypt', 'agypten': 'Egypt', 'ägypten': 'Egypt', 'egypt': 'Egypt',
    'finlande': 'Finland', 'finlandia': 'Finland', 'finnland': 'Finland', 'finland': 'Finland',
    'france': 'France', 'francia': 'France', 'frankreich': 'France',
    'allemagne': 'Germany', 'alemania': 'Germany', 'deutschland': 'Germany', 'germany': 'Germany',
    'grece': 'Greece', 'grèce': 'Greece', 'grecia': 'Greece', 'griechenland': 'Greece', 'greece': 'Greece',
    'islande': 'Iceland', 'islandia': 'Iceland', 'island': 'Iceland', 'iceland': 'Iceland',
    'indonesie': 'Indonesia', 'indonésie': 'Indonesia', 'indonesia': 'Indonesia', 'indonesien': 'Indonesia',
    'irlande': 'Ireland', 'irlanda': 'Ireland', 'irland': 'Ireland', 'ireland': 'Ireland',
    'italie': 'Italy', 'italia': 'Italy', 'italien': 'Italy', 'italy': 'Italy',
    'japon': 'Japan', 'japón': 'Japan', 'japan': 'Japan',
    'madagascar': 'Madagascar', 'madagaskar': 'Madagascar',
    'malaisie': 'Malaysia', 'malasia': 'Malaysia', 'malaysia': 'Malaysia',
    'maldives': 'Maldives', 'maldivas': 'Maldives', 'malediven': 'Maldives',
    'malte': 'Malta', 'malta': 'Malta',
    'maurice': 'Mauritius', 'ile maurice': 'Mauritius', 'île maurice': 'Mauritius', 'mauricio': 'Mauritius', 'mauritius': 'Mauritius',
    'mexique': 'Mexico', 'mexico': 'Mexico', 'méxico': 'Mexico', 'mexiko': 'Mexico',
    'maroc': 'Morocco', 'marruecos': 'Morocco', 'marokko': 'Morocco', 'morocco': 'Morocco',
    'namibie': 'Namibia', 'namibia': 'Namibia',
    'pays bas': 'Netherlands', 'paises bajos': 'Netherlands', 'países bajos': 'Netherlands',
    'holanda': 'Netherlands', 'hollande': 'Netherlands', 'niederlande': 'Netherlands', 'holland': 'Netherlands', 'netherlands': 'Netherlands',
    'nouvelle zelande': 'New Zealand', 'nouvelle-zélande': 'New Zealand', 'nueva zelanda': 'New Zealand', 'neuseeland': 'New Zealand', 'new zealand': 'New Zealand',
    'norvege': 'Norway', 'norvège': 'Norway', 'noruega': 'Norway', 'norwegen': 'Norway', 'norway': 'Norway',
    'oman': 'Oman',
    'philippines': 'Philippines', 'filipinas': 'Philippines', 'philippinen': 'Philippines',
    'portugal': 'Portugal',
    'arabie saoudite': 'Saudi Arabia', 'arabia saudita': 'Saudi Arabia', 'arabia saudi': 'Saudi Arabia',
    'saudi arabien': 'Saudi Arabia', 'saudi-arabien': 'Saudi Arabia', 'saudi arabia': 'Saudi Arabia',
    'senegal': 'Senegal', 'sénégal': 'Senegal',
    'afrique du sud': 'South Africa', 'sudafrica': 'South Africa', 'sudáfrica': 'South Africa',
    'sudafrika': 'South Africa', 'südafrika': 'South Africa', 'south africa': 'South Africa',
    'coree du sud': 'South Korea', 'corée du sud': 'South Korea', 'coree': 'South Korea', 'corée': 'South Korea',
    'corea del sur': 'South Korea', 'corea': 'South Korea', 'sudkorea': 'South Korea', 'südkorea': 'South Korea', 'south korea': 'South Korea',
    'espagne': 'Spain', 'espana': 'Spain', 'españa': 'Spain', 'spanien': 'Spain', 'spain': 'Spain',
    'sri lanka': 'Sri Lanka',
    'tanzanie': 'Tanzania', 'tanzania': 'Tanzania', 'tansania': 'Tanzania',
    'thailande': 'Thailand', 'thaïlande': 'Thailand', 'tailandia': 'Thailand', 'thailand': 'Thailand',
    'tunisie': 'Tunisia', 'tunez': 'Tunisia', 'túnez': 'Tunisia', 'tunesien': 'Tunisia', 'tunisia': 'Tunisia',
    'turquie': 'Turkey', 'turquia': 'Turkey', 'turquía': 'Turkey', 'turkei': 'Turkey', 'türkei': 'Turkey', 'turkey': 'Turkey',
    'emirats arabes unis': 'United Arab Emirates', 'émirats arabes unis': 'United Arab Emirates',
    'emiratos arabes unidos': 'United Arab Emirates', 'emiratos árabes unidos': 'United Arab Emirates',
    'vereinigte arabische emirate': 'United Arab Emirates', 'united arab emirates': 'United Arab Emirates', 'uae': 'United Arab Emirates',
    'royaume uni': 'United Kingdom', 'angleterre': 'United Kingdom', 'reino unido': 'United Kingdom',
    'inglaterra': 'United Kingdom', 'vereinigtes konigreich': 'United Kingdom', 'vereinigtes königreich': 'United Kingdom',
    'grossbritannien': 'United Kingdom', 'großbritannien': 'United Kingdom', 'england': 'United Kingdom', 'united kingdom': 'United Kingdom',
    'etats unis': 'United States', 'états-unis': 'United States', 'estados unidos': 'United States',
    'vereinigte staaten': 'United States', 'usa': 'United States', 'amerique': 'United States', 'america': 'United States', 'united states': 'United States',
    'vietnam': 'Vietnam', 'viet nam': 'Vietnam'
  };

  // Cles + valeurs normalisees une fois pour toutes.
  var NMAP = {};
  Object.keys(MAP).forEach(function (k) { NMAP[norm(k)] = norm(MAP[k]); });

  /* Ensemble des pays (anglais normalises) vises par un terme tape : tout alias
     qui COMMENCE par le terme, pour accepter la frappe partielle ("grec" -> grece).
     Retourne un objet { paysNormalise: 1 }. */
  function countriesFor(term) {
    term = norm(term);
    var out = {};
    if (term.length < 2) return out;
    for (var k in NMAP) { if (k.indexOf(term) === 0) out[NMAP[k]] = 1; }
    return out;
  }

  root.SVCountry = { norm: norm, map: NMAP, countriesFor: countriesFor };
})(typeof window !== 'undefined' ? window : this);
